<template>
  <UDashboardGroup unit="rem">
    <UDashboardSidebar
      v-model:open="open"
      collapsible
    >
      <template #default="{ collapsed }">
        <AppLogo :collapsed="collapsed" />

        <UNavigationMenu
          :collapsed="collapsed"
          :items="visibleLinks[0]"
          orientation="vertical"
          tooltip
          popover
        />
      </template>

      <template #footer="{ collapsed }">
        <AppProfileMenu
          :collapsed="collapsed"
          :display-name="[user.first_name, user.last_name].join(' ')"
        />
      </template>
    </UDashboardSidebar>

    <UDashboardPanel>
      <template #body>
        <slot />
      </template>
    </UDashboardPanel>
  </UDashboardGroup>
</template>

<script setup lang="ts">
import { links } from "@/utils/navigation";

const filterStore = useFilterStore();
const { filters: availableFilter } = storeToRefs(filterStore);
const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const open = ref(false);

const visibleLinks = computed(
  () =>
    links?.map((group) =>
      group.filter(
        (link) =>
          authStore.hasPermissions(link.permissions) &&
          authStore.hasNavigationRoleAccess(link),
      ),
    ) || [],
);

const getFilters = async () => {
  availableFilter.value = undefined;
  try {
    const res = await filterStore.getAvailableFilters();
    availableFilter.value = res;
  } catch (err) {
    console.error(err);
  }
};
onMounted(() => {
  getFilters();
});
</script>

<style scoped></style>
